import { fork, take, call, put, all } from "redux-saga/effects";
import {
  sendSkillsInterestResponse,
  sendSkillsInterestFailure,
  coachingRequestSubmitResponse,
  getSlotsResponse,
  registerCoachResponse,
  createSlotsResponse,
  getSessionNotesResponse,
  getCoachingListingRes,
  addSessionNotesResponse,
  deleteSlotsResponse,
  CoachRatingRes,
  getCoachingPersonalListingRes,
  GetCoachRatingRes,
  GetMasterIndustryDataRes,
  GetCoachingServicesRes,
  GetCoachingServiceDetailRes,
  getCoachingRequestSendResponse,
  getCoachingRequestsListResponse,
  rescheduleSlotsResponse,
  getCoachingRequestUpdateResponse,
  getMyBookingRequestResponse,
  addSlotsResponse,
  getAICoachingUrlResponse,
} from "./actions";
import {
  getAllCoaching,
  getAllCoachingResponse,
  getAllCoachingClear,
  getAllSkillsResponse,
} from "./actions";
import types from "./types";
import { apiDirect, postAPIWithoutModule } from "../../api/generic";

export function* doCoaching() {
  while (true) {
    const { payload } = yield take(types.COACHING_LIST);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getAllCoachingResponse(response));
  }
}

export function* doSkills() {
  while (true) {
    const { payload } = yield take(types.CS_GETSKILL);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getAllSkillsResponse(response));
  }
}

export function* doSubmitCoachingForm() {
  while (true) {
    const { payload } = yield take(types.COACHING_REQUEST_SUBMIT);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(coachingRequestSubmitResponse(response));
  }
}

export function* doGetSlots() {
  while (true) {
    const { payload } = yield take(types.GET_SLOTS);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getSlotsResponse(response));
  }
}

export function* doCreateSlots() {
  while (true) {
    const { payload } = yield take(types.CREATE_SLOTS);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(createSlotsResponse(response));
  }
}

export function* doAddSlots() {
  while (true) {
    const { payload } = yield take(types.ADD_SLOTS);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(addSlotsResponse(response));
  }
}

export function* doDeleteSlots() {
  while (true) {
    const { payload } = yield take(types.DELETE_SLOTS);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(deleteSlotsResponse(response));
  }
}

export function* doRegisterCoach() {
  while (true) {
    const { payload } = yield take(types.REGISTER_COACH);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(registerCoachResponse(response));
  }
}

export function* doGetSessionNotes() {
  while (true) {
    const { payload } = yield take(types.GET_SESSION_NOTES_LISTING);
    const response = yield call(postAPIWithoutModule, payload);
    console.log("response11", response);
    yield put(getSessionNotesResponse(response));
  }
}

export function* doAddSessionNotes() {
  while (true) {
    const { payload } = yield take(types.ADD_SESSION_NOTES);
    const response = yield call(postAPIWithoutModule, payload);
    console.log("response11", response);
    yield put(addSessionNotesResponse(response));
  }
}

export function* doCoachRating() {
  while (true) {
    const { payload } = yield take(types.COACH_RATING);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(CoachRatingRes(response));
  }
}

export function* doGetCoachingListing() {
  while (true) {
    const { payload } = yield take(types.COACHING_LISTING);
    const response = yield call(apiDirect, payload);
    yield put(getCoachingListingRes(response));
  }
}

export function* doGetCoachingPersonalListing() {
  while (true) {
    const { payload } = yield take(types.COACHING_PERSONAL_LISTING);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getCoachingPersonalListingRes(response));
  }
}
export function* doGetCoachRating() {
  while (true) {
    const { payload } = yield take(types.GET_COACH_RATING);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(GetCoachRatingRes(response));
  }
}
export function* doGetMasterIndustryData() {
  while (true) {
    const { payload } = yield take(types.GET_MASTER_INDUSTRY_DATA);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(GetMasterIndustryDataRes(response));
  }
}

export function* doGetCoachingServices() {
  while (true) {
    const { payload } = yield take(types.GET_COACHING_SERVICES);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(GetCoachingServicesRes(response));
  }
}
export function* doGetCoachingServiceDetail() {
  while (true) {
    const { payload } = yield take(types.GET_COACHING_SERVICE_DETAIL);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(GetCoachingServiceDetailRes(response));
  }
}

export function* doGetCoachingRequestSend() {
  while (true) {
    const { payload } = yield take(types.COACHING_REQUEST_SEND);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getCoachingRequestSendResponse(response));
  }
}

export function* doGetCoachingRequestsList() {
  while (true) {
    const { payload } = yield take(types.COACHING_REQUESTS_LIST);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getCoachingRequestsListResponse(response));
  }
}

export function* doRescheduleSlots() {
  while (true) {
    const { payload } = yield take(types.RESCHEDULE_SLOTS);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(rescheduleSlotsResponse(response));
  }
}

export function* doGetCoachingRequestUpdate() {
  while (true) {
    const { payload } = yield take(types.COACHING_REQUESTS_UPDATE);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getCoachingRequestUpdateResponse(response));
  }
}

export function* doGetMyBookingRequest() {
  while (true) {
    const { payload } = yield take(types.GET_MY_BOOKING_LIST);
    const response = yield call(apiDirect, payload);
    yield put(getMyBookingRequestResponse(response));
  }
}

export function* doGetAICoachingUrl() {
  while (true) {
    const { payload } = yield take(types.AI_COACHING_URL);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getAICoachingUrlResponse(response));
  }
}

function* coaching() {
  yield fork(doCoaching);
  yield fork(doSkills);
  yield fork(doSubmitCoachingForm);
  yield fork(doGetSlots);
  yield fork(doRegisterCoach);
  yield fork(doCreateSlots);
  yield fork(doAddSlots);
  yield fork(doDeleteSlots);
  yield fork(doGetSessionNotes);
  yield fork(doGetCoachingListing);
  yield fork(doGetCoachingListing);
  yield fork(doAddSessionNotes);
  yield fork(doCoachRating);
  yield fork(doGetCoachingPersonalListing);
  yield fork(doGetCoachRating);
  yield fork(doGetMasterIndustryData);
  yield fork(doGetCoachingServices);
  yield fork(doGetCoachingServiceDetail);
  yield fork(doGetCoachingRequestSend);
  yield fork(doGetCoachingRequestsList);
  yield fork(doRescheduleSlots);
  yield fork(doGetCoachingRequestUpdate);
  yield fork(doGetMyBookingRequest);
  yield fork(doGetAICoachingUrl);
}

export default coaching;
